import { EGeneralSearchSnippetType } from '@/types/search';
import DeliveryGuideSnippet from './DeliveryGuideSnippet';
import FaceToFaceDiagnosisSnippet from './FaceToFaceDiagnosisSnippet';
import FaceToFacePrescriptionSnippet from './FaceToFacePrescriptionSnippet';
import NonFaceToFaceDiagnosisSnippet from './NonFaceToFaceDiagnosisSnippet';
import NonFaceToFacePrescriptionSnippet from './NonFaceToFacePrescriptionSnippet';

interface Props {
  keyword: string;
  snippet?: EGeneralSearchSnippetType;
  navigateToDoctorList: (type: EGeneralSearchSnippetType) => void;
}

const SnippetByKeyword = ({ keyword, snippet, navigateToDoctorList }: Props) => {
  if (!snippet) return null;

  switch (snippet) {
    case EGeneralSearchSnippetType.NonFaceToFaceDiagnosis:
      return (
        <NonFaceToFaceDiagnosisSnippet keyword={keyword} navigateToDoctorList={() => navigateToDoctorList(snippet)} />
      );
    case EGeneralSearchSnippetType.NonFaceToFacePrescription:
      return (
        <NonFaceToFacePrescriptionSnippet
          keyword={keyword}
          navigateToDoctorList={() => navigateToDoctorList(snippet)}
        />
      );
    case EGeneralSearchSnippetType.FaceToFaceDiagnosis:
      return <FaceToFaceDiagnosisSnippet keyword={keyword} />;
    case EGeneralSearchSnippetType.FaceToFacePrescription:
      return <FaceToFacePrescriptionSnippet keyword={keyword} />;
    case EGeneralSearchSnippetType.DeliveryGuide:
      return <DeliveryGuideSnippet />;
    default:
      return null;
  }
};

export default SnippetByKeyword;
